import backupProducts from 'components/pantry/productData';
import { GET_PRODUCTS_RESPONSE, GET_PRODUCTS_ERROR } from 'actions/pantry';

const initialState = {};

export default (state = initialState, action = { type: null, response: null }) => {
  const { response, type } = action;
  switch (type) {
    case GET_PRODUCTS_RESPONSE:
      return { ...state, ...response.products };
    case GET_PRODUCTS_ERROR:
      return { ...state, ...backupProducts };
    default:
      return state;
  }
};
